var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-tab"},[_c('li',{staticClass:"w-100",class:[_vm.active, 'preview-tab'],on:{"click":_vm.onChangeTab}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }